import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import IrpTabs from "./IrpTabs";

export default function Irp() {
  return (
    <div className="relative isolate overflow-hidden text-ternary-dark dark:text-ternary-light px-6 pt-24 sm:pt-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            width="100%"
            height="100%"
            strokeWidth={0}
            fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)"
          />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl  gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:items-start lg:gap-y-10">
        <div className=" lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 ">
                Planning for Retirement
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight  sm:text-4xl">
                Individual Retirement Plans{" "}
              </h1>
            </div>
          </div>
        </div>

        <div className=" lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className=" text-base leading-7  ">
              <p>
                Creating a retirement strategy is vitally important. You need to
                start saving for retirement as soon as you start earning income.
                The sooner you start, the more you’ll accumulate. Our pension
                plans will ensure that you will have a consistent source of
                income and allow you to maintain your lifestyle in the future.
              </p>
              <h5>
                <strong>Types of Individual Retirement Plans</strong>
              </h5>
              <p>
                We have two retirement savings options that will make sure that
                you’ll have the income you need as you head into retirement. The
                key difference between the two is the mode of payment at
                retirement.
              </p>
              <ul className="list-disc list-inside">
                <li>
                  <b>Pension plan -</b>A third of accumulated benefit will be
                  paid as a single lump sum amount and the remaining two thirds.
                  Paid as a regular income for life upon retirement. Can be
                  withdrawn from the fund in a minimum of 10 years.
                </li>
                <li>
                  <b>Provident plan -</b>The accumulated amount will be paid in
                  one single lump sum upon retirement
                </li>
              </ul>

              <p className="">
                Your savings will grow exponentially over time while earning
                interest. On attainment of your selected retirement age, Britam
                will pay your accumulated retirement benefits in accordance to
                the option selected at the inception of the policy.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="  lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 pt-8 lg:px-8">
        <IrpTabs/>
      </div>
    </div>
  );
}
